module.exports = __webpack_public_path__ + "img/tips8.9afe9d06.png";